module.exports = __webpack_public_path__ + "img/tab4.af11c87f.png";